// utils for list props (account-level artifact)
import type { List } from 'flow/store/engine/types';
import { generatePublicIdHash } from 'flow/service/publicIds';

export function indexListsByName(lists: List[]): Record<List['list_name'], List> {
  return Object.fromEntries(lists.map(list => [list.list_name, list]));
}

export function isListEphemeral(list: List): boolean {
  if (!list) return false;
  return Boolean(list.is_ephemeral);
}

export function generateTemporaryListToken(): string {
  return `TEMP-I-${generatePublicIdHash(20)}`;
}
